// extracted by mini-css-extract-plugin
export var addButton = "_n5-0";
export var border = "_n5-8";
export var check = "_n5-h";
export var danger = "_n5-6";
export var dropdownContainer = "_n5-1";
export var editModalBody = "_n5-j";
export var footerContainer = "_n5-i";
export var fullWidth = "_n5-a";
export var hide = "_n5-9";
export var icon = "_n5-3";
export var input = "_n5-7";
export var inputFlex = "_n5-b";
export var inputWrapper = "_n5-c";
export var manualFocus = "_n5-5";
export var optionButton = "_n5-4";
export var pillWrapper = "_n5-e";
export var pointer = "_n5-2";
export var showOverflow = "_n5-f";
export var tagsFlex = "_n5-d";
export var xButton = "_n5-g";